const applicationManagerKPIs = [
    {
        "uuid": "1",
        "appType": "初次申請",
        "projectManager": "人員A",
        "appQuantity": "",
        "resolutionSentTimes": "",
        "resolutionCorrectRate": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
        "reviewDesc": "1.\tA21100211樣版其他內容未刪除 \n" +
            "2.\tA21100211引用錯條文\n",
    },
    {
        "uuid": "2",
        "appType": "定追",
        "projectManager": "人員A",
        "appQuantity": "",
        "resolutionSentTimes": "",
        "resolutionCorrectRate": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
        "reviewDesc": "",
    },
    {
        "uuid": "3",
        "appType": "展延",
        "projectManager": "人員A",
        "appQuantity": "",
        "resolutionSentTimes": "",
        "resolutionCorrectRate": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
        "reviewDesc": "",
    },
    {
        "uuid": "4",
        "appType": "小計",
        "projectManager": "",
        "appQuantity": "",
        "resolutionSentTimes": "",
        "resolutionCorrectRate": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
        "reviewDesc": "",
    },
    {
        "uuid": "5",
        "appType": "定追",
        "projectManager": "人員B",
        "appQuantity": "",
        "resolutionSentTimes": "",
        "resolutionCorrectRate": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
        "reviewDesc": "",
    },
    {
        "uuid": "6",
        "appType": "異動",
        "projectManager": "人員B",
        "appQuantity": "",
        "resolutionSentTimes": "",
        "resolutionCorrectRate": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
        "reviewDesc": "",
    },
    {
        "uuid": "7",
        "appType": "外標示",
        "projectManager": "人員B",
        "appQuantity": "",
        "resolutionSentTimes": "",
        "resolutionCorrectRate": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
        "reviewDesc": "",
    },
    {
        "uuid": "8",
        "appType": "小計",
        "projectManager": "",
        "appQuantity": "",
        "resolutionSentTimes": "",
        "resolutionCorrectRate": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
        "reviewDesc": "",
    },
    {
        "uuid": "9",
        "appType": "總計",
        "projectManager": "",
        "appQuantity": "",
        "resolutionSentTimes": "",
        "resolutionCorrectRate": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
        "reviewDesc": "",
    },
]

export default applicationManagerKPIs;